import { Card, CardHeader } from "@peer-start/ui";
import { FileText } from "lucide-react";
import { useTranslation } from "react-i18next";
import { demoCertificates, demoDiplomas, type ProfileCredentialId } from "./profile-credentials-data.js";

function CredentialItem({ item }: { item: ProfileCredentialId }) {
  const { t } = useTranslation();
  return (
    <div className="flex items-start gap-3 rounded-xl border border-border/70 bg-background p-3.5">
      <span className="grid size-10 shrink-0 place-items-center rounded-lg bg-success text-success-foreground">
        <FileText aria-hidden="true" className="size-5" strokeWidth={1.7} />
      </span>
      <div className="min-w-0">
        <p className="text-sm font-medium text-foreground">{t(item.titleKey)}</p>
        <p className="mt-1 text-xs leading-relaxed text-muted-foreground">{t(item.metaKey)}</p>
      </div>
    </div>
  );
}

function CredentialList({
  items,
  emptyLabel,
}: {
  items: readonly ProfileCredentialId[];
  emptyLabel: string;
}) {
  if (!items.length) {
    return <p className="text-sm text-muted-foreground">{emptyLabel}</p>;
  }
  return (
    <ul className="space-y-3">
      {items.map((item) => (
        <li key={item.id}>
          <CredentialItem item={item} />
        </li>
      ))}
    </ul>
  );
}

export function ProfileCredentialsTab() {
  const { t } = useTranslation();

  return (
    <div className="grid gap-5 lg:grid-cols-2">
      <Card aria-label={t("profile.earnedCertificates")}>
        <CardHeader title={t("profile.earnedCertificates")} />
        <CredentialList emptyLabel={t("profile.noCertificates")} items={demoCertificates} />
      </Card>
      <Card aria-label={t("profile.diplomas")} className="h-fit self-start">
        <CardHeader title={t("profile.diplomas")} />
        <CredentialList emptyLabel={t("profile.noDiplomas")} items={demoDiplomas} />
      </Card>
    </div>
  );
}
